// @flow
import React from 'react';
import { components } from 'react-select';
import { cx } from 'emotion';

function MultiValueRemove(props: any) {
  if (props.data.unclearableValue) {
    return null;
  }
  const { innerProps, ...rest } = props;
  const className = cx(innerProps.className, 'Select-value-icon');
  const newProps = {
    ...rest,
    innerProps: {
      ...innerProps,
      className
    }
  };

  return <components.MultiValueRemove {...newProps} />;
}

export default MultiValueRemove;
